// extracted by mini-css-extract-plugin
export default {"container":"GeneralFour_container__lGgi3","people":"GeneralFour_people__Nzv8K"};